export const CORRECTION_BATCH_SIZE = 20;
export const CORRECTION_BATCH_THRESHOLD = 15;
export const CORRECTION_MAX_TOKENS_SINGLE = 8000;
export const CORRECTION_MAX_TOKENS_CHUNK = 6000;

export const GAME_TYPE_LABELS = {
  speed_game: 'Speed Game (QCM sur des mots)',
  text_holes: 'Texte à trous',
  correction_game: 'Jeu de correction de texte',
  word_lists: 'Liste de mots',
  dictation: 'Dictée',
  word_choice: 'Dictée guidée',
  association: 'Association par paires',
  categorisation: 'Catégorisation',
  speed_sort: 'Speed Sort',
};

const SPLITTABLE_ARRAY_KEYS = {
  speed_game: 'words',
  text_holes: 'blanks',
  word_lists: 'words',
  word_choice: 'wordChoices',
  association: 'pairs',
  categorisation: 'items',
  speed_sort: 'sortItems',
};

export function getSplittableArray(gameType, content) {
  const key = SPLITTABLE_ARRAY_KEYS[gameType];
  if (!key || !Array.isArray(content?.[key])) return null;
  return { key, items: content[key] };
}

export function chunkArray(items, size = CORRECTION_BATCH_SIZE) {
  const chunks = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
}

// NB : le prompt de correction est désormais construit côté backend
// (services/exerciseCorrectionService.js) pour réutiliser les mêmes règles
// par type que la correction en masse. Cf. route POST /admin/exercises/correct-llm.

export function parseLLMJsonResponse(raw) {
  const trimmedRaw = (raw || '').trim();
  const stripped = trimmedRaw.replace(/^```(?:json)?\s*/i, '').replace(/\s*```\s*$/, '').trim();

  try {
    return JSON.parse(stripped);
  } catch {
    const match = raw.match(/\{[\s\S]*\}/);
    if (match) {
      return JSON.parse(match[0]);
    }
    throw new Error('Réponse LLM non parseable en JSON');
  }
}

export function mergeCorrectedChunks(originalContent, arrayKey, chunkContents) {
  const mergedItems = chunkContents.flatMap((chunkContent) => {
    const items = chunkContent?.[arrayKey];
    return Array.isArray(items) ? items : [];
  });

  return {
    ...originalContent,
    [arrayKey]: mergedItems,
  };
}
